import { NgModule } from '@angular/core';

import { NotLinkedToAccountWindowComponent } from './not-linked-to-account-window.component';

@NgModule({
  declarations: [
    NotLinkedToAccountWindowComponent,
  ],
  exports: [
    NotLinkedToAccountWindowComponent,
  ],
})
export class NotLinkedToAccountWindowModule {
}
